import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const links = [
  { label: "Problem", href: "#problem" },
  { label: "Solution", href: "#solution" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Benefits", href: "#benefits" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/75 backdrop-blur-xl border-b border-slate-200/60" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/invoquity-logo.png" alt="Invoquity" className="h-8 w-auto" />
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors">
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <span data-testid="nav-launch-badge" className="hidden sm:inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold tracking-wide text-emerald-800">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-700 mr-2 animate-pulse" />
            Launching Soon
          </span>
          <a href="#early-access" data-testid="nav-cta-btn"
             className="hidden sm:inline-flex items-center rounded-full bg-gradient-to-r from-emerald-700 to-emerald-800 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:shadow-glow-blue hover:-translate-y-0.5 transition-all">
            Join Early Access
          </a>
          <button data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)}
                  className="md:hidden inline-grid place-items-center w-10 h-10 rounded-lg border border-slate-200 bg-white/80 text-slate-700">
            {open ? <X size={18} /> : <List size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-slate-200/70 bg-white/95 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                 className="text-sm font-medium text-slate-700 py-2">
                {l.label}
              </a>
            ))}
            <a href="#early-access" onClick={() => setOpen(false)}
               className="mt-2 rounded-full bg-emerald-700 px-5 py-3 text-center text-sm font-semibold text-white">
              Join Early Access
            </a>
          </div>
        </div>
      )}
    </motion.nav>
  );
}
